export default from './Contact'



// WEBPACK FOOTER //
// ./app/views/Contact/index.js